import { render, staticRenderFns } from "./sendLink.vue?vue&type=template&id=e4ddd04a&scoped=true&"
import script from "./sendLink.vue?vue&type=script&lang=js&"
export * from "./sendLink.vue?vue&type=script&lang=js&"
import style0 from "./sendLink.vue?vue&type=style&index=0&id=e4ddd04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ddd04a",
  null
  
)

export default component.exports